// extracted by mini-css-extract-plugin
export default {"spacerFlat":"Sidebar_spacerFlat__EpsyH","content":"Sidebar_content__5XQsQ"};